module.exports = __webpack_public_path__ + "static/icons/icon-insurance-d5573b2dd70858b6cf50f3e96418d85e.svg";